import { render, staticRenderFns } from "./TaskDeleteDialog.vue?vue&type=template&id=661a69a8&scoped=true"
import script from "./TaskDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./TaskDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./TaskDeleteDialog.vue?vue&type=style&index=0&id=661a69a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a69a8",
  null
  
)

export default component.exports